export function syncUserSelectedSources(
  next: Set<number>,
  setSelectedSources: (next: Set<number>) => void,
) {
  setSelectedSources(next);
}
